export const isSystemManagedUrl = 'http://narushealth.com/isSystemManaged'

export const isSystemManaged = {
  fhir: [ 'extension', { url: isSystemManagedUrl }, 'valueBoolean' ],
  form: [ 'isSystemManaged' ]
}
